define("shared/components/shared/choose-your-upgrade/plan-card", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Ui::Button
    @onClick={{this.handleCardClick}}
    @variant="unstyled"
    class="cCU--upgradeCard
      {{concat 'cCU--upgradeCard--' (lowercase this.plan.planName)}}
      {{if @isSelected 'cCU--upgradeCard--active'}}"
  >
    <div class="cCU--upgradeCard__input">
      <input
        checked={{@isSelected}}
        class="o--form__radio u--m__r__sm {{concat 'qa--branding_options_' (lowercase this.plan.planName) '_radio_btn'}}"
        name="title"
        type="radio"
      />
      {{this.plan.title}}
    </div>
  
    <img class="cCU--upgradeCard__img" src={{this.plan.image}} />
  
    <div class="u--m__t">
      <p class="u--text--base">
        <span class="u--text--bold cCU--upgradeCard__planName">
          {{t (concat "plans.choose_your_upgrade.plan." this.plan.planName)}}
        </span>
        {{t "plans.choose_your_upgrade.includes"}}
      </p>
  
      <ul class="u--listUnstyle u--text--base">
        {{#each this.plan.highlights as |highlight|}}
          <li>
            {{svg-jar "verified" class="u--text--bold o--icon cCU--upgradeCard__icon"}}
            {{highlight}}
          </li>
        {{/each}}
      </ul>
    </div>
  </Shared::Ui::Button>
  */
  {
    "id": "k0qJTkCp",
    "block": "[[[8,[39,0],[[16,0,[29,[\"cCU--upgradeCard\\n    \",[28,[37,1],[\"cCU--upgradeCard--\",[28,[37,2],[[30,0,[\"plan\",\"planName\"]]],null]],null],\"\\n    \",[52,[30,1],\"cCU--upgradeCard--active\"]]]]],[[\"@onClick\",\"@variant\"],[[30,0,[\"handleCardClick\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,0],[14,0,\"cCU--upgradeCard__input\"],[12],[1,\"\\n    \"],[10,\"input\"],[15,\"checked\",[30,1]],[15,0,[29,[\"o--form__radio u--m__r__sm \",[28,[37,1],[\"qa--branding_options_\",[28,[37,2],[[30,0,[\"plan\",\"planName\"]]],null],\"_radio_btn\"],null]]]],[14,3,\"title\"],[14,4,\"radio\"],[12],[13],[1,\"\\n    \"],[1,[30,0,[\"plan\",\"title\"]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"img\"],[14,0,\"cCU--upgradeCard__img\"],[15,\"src\",[30,0,[\"plan\",\"image\"]]],[12],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"u--m__t\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--text--base\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--bold cCU--upgradeCard__planName\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[[28,[37,1],[\"plans.choose_your_upgrade.plan.\",[30,0,[\"plan\",\"planName\"]]],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[1,[28,[35,4],[\"plans.choose_your_upgrade.includes\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--text--base\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"plan\",\"highlights\"]]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"verified\"],[[\"class\"],[\"u--text--bold o--icon cCU--upgradeCard__icon\"]]]],[1,\"\\n          \"],[1,[30,2]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[2]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]]],[\"@isSelected\",\"highlight\"],false,[\"shared/ui/button\",\"concat\",\"lowercase\",\"if\",\"t\",\"each\",\"-track-array\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/choose-your-upgrade/plan-card.hbs",
    "isStrictMode": false
  });

  let PlanCardComponent = (_class = class PlanCardComponent extends _component2.default {
    get plan() {
      return this.args.planDetails;
    }

    handleCardClick(event) {
      event.preventDefault();
      this.args.setSelectedUpgradeFeature(this.plan.upgradeFeature);
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "handleCardClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCardClick"), _class.prototype)), _class);
  _exports.default = PlanCardComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PlanCardComponent);
});